import React, { useContext, useEffect, useState } from 'react'
import DataTable, { Alignment, defaultThemes } from 'react-data-table-component'
import AddNewSession from './AddNewSession';
import { addcontext } from '../../ContextShare/ContextShare';
import { DeleteSession, EditSession, FilterSessionByKLATableAdmin, GetKlaListForSearchFilter, GetSessionListTable, hideSession } from '../../Services/allApi';
import { Icon } from '@iconify/react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
// import Select from "react-select";
import EditMemberMapping from './EditMemberMapping';
import EditSittings from './EditSittings';
import DeleteModal from '../DeleteModal';
import PopoverIcon from '../../Components/InfoIcon'
import PopOver from '../../Components/PopOver';
import SyncLoader from "react-spinners/SyncLoader";
import '../loaderStyles.css'
import Select, { components } from 'react-select';
import { useNavigate } from 'react-router-dom';
import AdminPagination from '../../Components/AdminPagination';
import { toast, ToastContainer } from 'react-toastify';

const CustomOption = (props) => {
    const { data, innerRef, innerProps } = props;

    if (data.value === 'addnewkla' || data.value === 'addnewsession') {
        return (
            <div
                className='hover:bg-green-500 hover:text-white text-green-500'
                ref={innerRef}
                {...innerProps}
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    // backgroundColor: 'lightyellow',
                    padding: '10px',
                    borderRadius: '5px',
                    cursor: 'pointer',
                }}
            >
                <span className='font-bold' >{data.label}</span>
                <Icon icon="basil:add-outline" className='ms-1 font-bold' />

            </div>
        );
    }

    return <components.Option {...props} />;
};
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

const styleMM = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '85%',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 2,
    maxHeight: '90%',
    overflowY: 'hidden' // Make the Box scrollable
};

const style4 = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

function TableSession() {
    const { addSession, setAddSession } = useContext(addcontext)
    const { paginationStartIndexAD, setPaginationStartIndexAD } = useContext(addcontext)
    const { paginationEndIndexAD, setPaginationEndIndexAD } = useContext(addcontext)
    const [totalSessions, setTotalSessions] = useState()
    const [refreshPagination, setRefreshPagination] = useState(false)
    const [isFiltered, setIsFiltered] = useState(false)
    const [sessionList, setSessionList] = useState([])
    const [token, setToken] = useState()
    const [editBox, setEditBox] = useState(false)
    const [dataToEdit, setDataToEdit] = useState()
    const [open, setOpen] = useState(false);
    const [isEdited, setIsEdited] = useState(1)
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const [openMM, setOpenMM] = useState(false);
    const [isEditedMM, setIsEditedMM] = useState(1)
    const handleOpenMM = () => setOpenMM(true);
    const handleCloseMM = () => setOpenMM(false);

    const [openSS, setOpenSS] = useState(false);
    const [isEditedSS, setIsEditedSS] = useState(1)
    const handleOpenSS = () => setOpenSS(true);
    const handleCloseSS = () => setOpenSS(false);

    const [klaList, setKlaList] = useState([])
    const [klaoptions, setKlaOptions] = useState([]);
    const [tableDetails, setTableDetails] = useState()
    const [idToDelete, setidToDelete] = useState()
    const [open4, setOpen4] = useState(false);
    const [errorMsg, setErrorMsg] = useState()
    const handleOpen4 = (IdToDlt) => {
        setidToDelete(IdToDlt)
        setOpen4(true);
    }
    const handleClose4 = () => {
        setOpen4(false);
        // setDataToEdit()
    }
    const [selectedOptionKla, setSelectedOptionKla] = useState(null);
    // const [selectedOptionsession, setSelectedOptionsession] = useState(null);
    const [klaListF, setKlaListF] = useState([]);
    const navigate = useNavigate()
    // const [sessionListF, setSessionListF] = useState([]);
    const customStyles = {

        rows: {
            style: {
                '&:nth-child(odd)': {
                    backgroundColor: '#F5F8FA',
                    minHeight: '50px',

                },
                '&:nth-child(even)': {
                    backgroundColor: 'white',
                    minHeight: '50px'
                },
                '&:nth-child(1)': {
                    backgroundColor: '#F5F8FA',
                    minHeight: '50px'
                },
                '&:nth-child(2)': {
                    backgroundColor: 'white',
                    minHeight: '50px'
                },
            },
        },
        header: {
            style: {
                minHeight: '4px',

            },
        },
        headRow: {
            style: {
                borderTopStyle: 'solid',
                borderTopWidth: '1px',
                borderTopColor: defaultThemes.default.divider.default,
                backgroundColor: '#18A0FB',
                color: 'white',
                height: '50px',

            },
        },
        headCells: {
            style: {
                '&:not(:last-of-type)': {
                    borderRightStyle: 'solid',
                    borderRightWidth: '1px',
                    borderRightColor: defaultThemes.default.divider.default,
                },
            },
        },
        cells: {

            style: {
                '&:not(:last-of-type)': {
                    borderRightStyle: 'solid',
                    borderRightWidth: '1px',
                    borderRightColor: defaultThemes.default.divider.default,


                    // backgroundColor:'red'
                },
            },
        },


        // // when: row => row.year >= 2021,
        // style: {
        // 	backgroundColor: 'rgba(248, 148, 6, 0.9)',
        // 	color: 'white',
        // 	'&:hover': {
        // 		cursor: 'pointer',
        // 	},
        // },
    };

    const columns = [
        {
            name: 'Sl No',
            selector: row => row.slno,
            sortable: true,


        },
        {
            name: 'Action',
            selector: row => row.Action,
            // sortable: true,
            // Set a fixed width for the "Action" column
            minWidth: '290px', // Adjust the width as needed
            // Optionally, you can also specify maxWidth to prevent the column from expanding beyond a certain width
            maxWidth: '310px',

        },
        {
            name: 'Id',
            selector: row => row.id,
            sortable: true,


        },

        {
            name: 'KLA',
            selector: row => row.kla,
            sortable: true,


        },
        {
            name: 'Session',
            selector: row => row.session,
            sortable: true,


        },

        {
            name: 'Start Date',
            selector: row => row.startdate,
            sortable: true,
        },
        {
            name: 'End Date',
            selector: row => row.enddate,
            sortable: true,
        },
        {
            name: 'Business Hours',
            selector: row => row.businesshours,
            sortable: true,
        },
        {
            name: 'Total Sittings',
            selector: row => row.totalsittings,
            sortable: true,
        },
        {
            name: 'Uploader',
            selector: row => row.uploader,
            sortable: true,
        },
        {
            name: 'Created at',
            selector: row => row.createdAt,
            sortable: true,
        },
        {
            name: 'Updated at',
            selector: row => row.updatedAt,
            sortable: true,
        },


        // {
        //     name: 'Visible',
        //     selector: row => row.visible,
        //     sortable: true,
        //     minWidth: '120px', // Adjust the width as needed
        //     maxWidth: '140px',
        // },
        {
            name: 'Active',
            selector: row => row.active,
            sortable: true,
        },

        // {
        //     name: 'Member mapping',
        //     selector: row => row.ActionMM,
        //     // sortable: true,
        // },

    ];

    useEffect(() => {
        setToken(sessionStorage.getItem('access_token'))
        if (token) {
            if (!isFiltered) {
                getSessionList()
                // setRefreshPagination(false)
            }
        }
        else {
            console.log('Token fetching failed');
        }
    }, [token, isEdited, addSession, paginationStartIndexAD, paginationEndIndexAD])



    const getSessionList = async () => {
        const reqHeader = {
            "Content-Type": "application/json",
            "Authorization": `${token}`
        };
        const result = await GetSessionListTable(reqHeader, paginationStartIndexAD, paginationEndIndexAD)
        setSessionList(result?.data?.data)
        setTotalSessions(result?.data?.count)
        setErrorMsg(result?.response?.data?.message)
        console.log(result);
    }

    const handleEditMMemberMapping = (item) => {
        console.log(item);
        handleOpenMM()
        setTableDetails(item)
    }

    const hideOrUnhide = async (SessionId) => {
        const token = sessionStorage.getItem('access_token')
        const reqHeader = {
            "Content-Type": "application/json",
            "Authorization": `${token}`
        };
        const response = await hideSession({ pk: SessionId }, reqHeader)
        // console.log(response);
        setIsEdited(isEdited + 1)
    }

    const deleteRow = async () => {
        handleClose4()
        const token = sessionStorage.getItem('access_token')
        const reqHeader = {
            "Content-Type": "application/json",
            "Authorization": `${token}`
        };
        const response = await DeleteSession(idToDelete, reqHeader)
        // console.log(response);
        setIsEdited(isEdited + 1)

    }

    var data = []
    //sets the value for each row assuming there are 50 rows
    sessionList && sessionList?.map((item, index) => {
        const slno = index + 1
        const id = item.session_id; // Assuming ids start from 1
        const session = `Session ${item.session_no}th`;
        const kla = `Kla ${item.kla}`;
        const startdate = item.session_start_date;
        const enddate = item.session_end_date;
        const businesshours = item.total_buisness_hours;
        const totalsittings = item.total_no_of_sitting;
        const uploader = item.uploaded_by
        const createdAt = item.created_at?.slice(0, 10)
        const updatedAt = item.updated_at?.slice(0, 10)
        const active = <div className='flex flex-row justify-center items-center text-red-500 p-1 rounded' style={{ cursor: 'pointer' }}>
            <button className='' onClick={() => handleOpen4(item.session_id)} >Delete</button>
            <Icon icon="ic:outline-delete" className='text-lg' />
        </div>

        const visible = <div className='flex flex-row justify-center items-center'>
            <Icon icon={`${item.is_visible ? 'fa-solid:check-circle' : 'fa-solid:times-circle'}`} style={{ color: `${item.is_visible ? 'green' : 'red'}` }} className='text-lg' />
            <button onClick={() => hideOrUnhide(item.session_id)} className='ms-2 text-white px-2 py-1 rounded' style={{ backgroundColor: '#18A0FB', cursor: 'pointer' }} >{item.is_visible ? 'Hide' : 'Unhide'}</button>
        </div>
        const Action = <div className='flex flex-row justify-center items-center'>
            <a style={{ cursor: 'pointer' }} className='border border-[#18A0FB] rounded px-1 py-1 flex flex-row items-center hover:bg-[#18A0FB] text-[#18A0FB] hover:text-white' onClick={() => handleEdit(item)}><span>Edit</span> <Icon icon="bxs:edit" className='' /></a>
            <a className='ms-2 text-white p-1 rounded' style={{ backgroundColor: '#18A0FB', cursor: 'pointer' }} onClick={() => handleEditMMemberMapping(item)}>Edit members</a>
            <a className='ms-2 text-white p-1 rounded' style={{ backgroundColor: '#18A0FB', cursor: 'pointer' }} onClick={() => handleEditSittings(item)}>Edit Sittings calendar</a>
        </div>
        // const Hide = <a style={{ color: '#FF0000', cursor: 'pointer' }}>Delete</a>;


        const newObj = { slno, id, session, kla, startdate, enddate, businesshours, totalsittings, uploader, createdAt, updatedAt, active, visible, Action };
        data.push(newObj);
    })

    const handleEdit = (item) => {
        setEditBox(true)
        setDataToEdit(item)
        handleOpen()
        klaListCallApi();


    }

    const klaListCallApi = async () => {
        try {
            const result = await GetKlaListForSearchFilter();
            // console.log(result);
            setKlaList(result?.data?.data)
            const options = result?.data?.data.map(item => ({
                value: item.kla_id,
                label: `KLA${item.kla_no}`,
                valueApi: item.kla_id
            }));

            setKlaOptions(options);


        } catch (error) {
            console.error("Error fetching Kla list for filter:", error);
        }
    }

    const handleSubmitEdit = async () => {
        const token = sessionStorage.getItem('access_token')
        const reqHeader = {
            "Content-Type": "application/json",
            "Authorization": `${token}`
        };

        dataToEdit.kla = dataToEdit?.kla?.value
        // console.log(dataToEdit);
        const result = await EditSession(dataToEdit, reqHeader)
        if (result.status == 200) {
            toast.success("Editing sucessfull")
            // console.log(result);
            handleClose()
            setIsEdited(isEdited + 1)
        }
        else {
            toast.error(result.response.data.message ?? 'There was a problem editing session')
        }

    }

    const handleEditSittings = (item) => {
        // console.log(item);
        handleOpenSS()
        setTableDetails(item)
    }

    // ------------------------------------------FILTER IN VIDEO----------------------------------------------
    // Fetch KLA List for filter
    const klaListCallApiFilter = async () => {
        try {
            const result = await GetKlaListForSearchFilter();
            setKlaListF(result?.data?.data || []);
        } catch (error) {
            console.error("Error fetching KLA list for filter:", error);
        }
    };

    useEffect(() => {
        klaListCallApiFilter();
    }, []);

    const klaoptionsF = klaListF.map((item) => ({
        value: item.kla_id,
        label: `KLA${item.kla_no}`,
    }));

    // Fetch Session List
    // const SessionListCallApiFilter = async () => {
    //     try {
    //         const resultSession = selectedOptionKla
    //             ? await GetSessionListForSearchFilterWithKla(selectedOptionKla.value)
    //             : await GetSessionListForSearchFilter();
    //         setSessionListF(resultSession?.data?.data || []);
    //     } catch (error) {
    //         console.error("Error fetching Session list for filter:", error);
    //     }
    // };

    // useEffect(() => {
    //     SessionListCallApiFilter();
    // }, [selectedOptionKla]);

    // const sessionoptionsF = sessionListF.map((item) => ({
    //     value: item.session_id,
    //     label: `Session${item.session_no}`,
    // }));

    const handlechange = (option) => {
        if (option?.value == 'addnewkla') {
            navigate('/octobersky/kla')
        }
        else {
            setSelectedOptionKla(option)
            setIsFiltered(true)
            setPaginationStartIndexAD(1)
            setPaginationEndIndexAD(25)
            setRefreshPagination(true)
        }
    }

    // const handlechangesession = (option) => setSelectedOptionsession(option);

    const FilterAdminVideoTable = async () => {
        const kla_id = selectedOptionKla?.value;
        // const session_id = selectedOptionsession?.value;
        // const member_id = selectedOptionMember?.value;
        // const event_id = selectedOptionEvent?.value;
        // const constituency_id = selectedOptionconstituency?.value;

        const obj = {};
        if (kla_id) obj.kla_id = kla_id;
        // if (session_id) obj.session_id = session_id;
        // if (member_id) obj.member_id = member_id;
        // if (event_id) obj.event_id = event_id;
        // if (constituency_id) obj.constituency_id = constituency_id;

        try {
            const reqHeader = {
                "Content-Type": "application/json",
                "Authorization": `${token}`
            };
            const result = await FilterSessionByKLATableAdmin(obj, reqHeader, paginationStartIndexAD, paginationEndIndexAD);
            console.log(result);
            setErrorMsg(result?.response?.data?.message)
            setSessionList(result?.data?.data || []);
        } catch (error) {
            console.error("Error filtering archives data:", error);
        }
    };

    useEffect(() => {
        if (selectedOptionKla) {
            if (isFiltered) {
                FilterAdminVideoTable()
            }
        }
    }, [selectedOptionKla, paginationStartIndexAD, paginationEndIndexAD]);

    // ------------------------------------------FILTER IN VIDEO END----------------------------------------------
    const handleResetFilter = () => {
        setSelectedOptionKla(null)
        getSessionList()
        setIsFiltered(false)
        setRefreshPagination(false)
        setErrorMsg()
        // setSelectedOptionsession(null)
        // GetProgressList()

    }
    //    const deleteScript=async()=>{
    //         const token = sessionStorage.getItem('access_token')
    //         const reqHeader = {
    //             "Content-Type": "application/json",
    //             "Authorization": `${token}`
    //         };
    //         for(var i=118;i<=219;i++){
    //             await DeleteSession(i, reqHeader)
    //         }
    //     }
    return (
        <>
            {addSession ?
                <AddNewSession />
                : <>
                    <div className='flex flex-row justify-center gap-5'>
                        <div className='flex flex-row w-3/12  text-blue-400'>

                            <Select
                                placeholder='KLA'
                                className='w-full'
                                // options={klaoptionsF}
                                value={selectedOptionKla}
                                onChange={handlechange}
                                options={[...klaoptionsF, { value: 'addnewkla', label: 'Add new kla' }]}
                                styles={{
                                    control: (baseStyles, state) => ({
                                        ...baseStyles,
                                        borderRadius: '0.5rem',
                                    }),
                                }}
                                components={{ Option: CustomOption }}

                            />

                        </div>

                        <div className='flex flex-col '>
                            <button onClick={handleResetFilter} className='flex flex-row gap-1 items-center rounded-lg w-full hover:bg-red-500 border text-red-500 hover:text-white border-red-500 h-9 px-2 transform duration-700 ease-in-out'>
                                <span>Clear Filter</span>
                                <Icon icon="bx:reset" />
                            </button>
                        </div>
                        {/* <PopoverIcon content="Update member details across each session" /> */}
                        {/* <div className='flex flex-row w-3/12 text-blue-400'>
                    <Select
                        placeholder='Session'
                        className='w-full'
                        options={sessionoptionsF}
                                value={selectedOptionsession}
                                onChange={handlechangesession}
                        />
                </div> */}
                    </div>

                    <>
                        {sessionList?.length > 0 ?

                            <div className='flex flex-col gap-1'>
                                {/* <button onClick={deleteScript}> activate delete script</button> */}
                                <DataTable
                                    title={<div className='flex flex-row items-center'><span className='me-2'>Session List</span> <PopOver dataToDisplay={'Update member details across each session'} /></div>}
                                    columns={columns}
                                    data={data}
                                    customStyles={customStyles}
                                    // pagination
                                    dense
                                    highlightOnHover
                                    selectableRowsHighlight
                                    paginationPerPage={50} // Initial page size
                                    paginationRowsPerPageOptions={[50, 100, 200, 500]} // Options for users to change page size
                                // selectableRows
                                // progressPending
                                // progressComponent={<h1>load</h1>}
                                />
                                {totalSessions>25&&<AdminPagination count={totalSessions} refresh={refreshPagination} />}
                            </div>
                            :
                            <>
                            {!errorMsg?<div className="flex justify-center items-center w-full h-full flex-col gap-5">
                                <SyncLoader
                                    color="#3498db"
                                    loading={true}
                                    speedMultiplier={1}
                                />
                                <p className="loading-text flex flex-row items-center"><span>Loading please wait</span><Icon className='text-lg' icon="eos-icons:three-dots-loading" /></p>

                            </div>
                            :
                            <div className="flex justify-center items-center w-full h-full flex-col gap-5">
                            <p className="text-red-500 flex flex-row items-center text-lg gap-1"><span>{errorMsg}</span><Icon icon="material-symbols:error-outline" className='text-lg' /></p>
                            </div>

                            }
                            </>
                            }
                    </>
                </>
            }

            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <div className='flex flex-col items-center justify-center w-full ' style={{ fontFamily: 'ropa sans' }}>
                        <div className='w-10/12 flex flex-col mt-10'>
                            <label htmlFor="eventname">Session</label>
                            <input
                                id='eventname'
                                value={dataToEdit?.session_no}
                                onChange={(e) => setDataToEdit({ ...dataToEdit, session_no: e.target.value })}
                                type="text"
                                className='bg-success w-full h-10 rounded-lg border border-dashed border-gray-700 px-2'
                            />
                        </div>
                        {/* Additional fields */}
                        <div className='w-10/12 flex flex-col mt-5'>
                            <label htmlFor="kla">KLA</label>
                            <Select
                                id='kla'
                                placeholder={dataToEdit?.kla}
                                options={klaoptions}
                                value={dataToEdit?.kla}
                                onChange={option => setDataToEdit({ ...dataToEdit, kla: option })}
                                styles={{
                                    control: (baseStyles, state) => ({
                                        ...baseStyles,
                                        borderColor: '#4a5568',
                                        height: '2.5rem',
                                        borderRadius: '0.5rem',
                                        borderStyle: 'dashed ',
                                        backgroundColor: '#F1F5F9'
                                    }),
                                }}
                            />
                        </div>
                        <div className='w-10/12 flex flex-col mt-5'>
                            <label htmlFor="field3">Start date</label>
                            <input
                                id='field3'
                                value={dataToEdit?.session_start_date}
                                onChange={(e) => setDataToEdit({ ...dataToEdit, session_start_date: e.target.value })}
                                type="date"
                                className='bg-success w-full h-10 rounded-lg border border-dashed border-gray-700 px-2'
                            />
                        </div>
                        <div className='w-10/12 flex flex-col mt-5'>
                            <label htmlFor="field4">End date</label>
                            <input
                                id='field4'
                                value={dataToEdit?.session_end_date}
                                onChange={(e) => setDataToEdit({ ...dataToEdit, session_end_date: e.target.value })}
                                type="date"
                                className='bg-success w-full h-10 rounded-lg border border-dashed border-gray-700 px-2'
                            />
                        </div>

                        <div className='w-10/12 flex flex-col mt-5'>
                            <label htmlFor="eventname">Total business hours</label>
                            <input
                                id='eventname'
                                value={dataToEdit?.total_buisness_hours}
                                onChange={(e) => setDataToEdit({ ...dataToEdit, total_buisness_hours: e.target.value })}
                                type="text"
                                className='bg-success w-full h-10 rounded-lg border border-dashed border-gray-700 px-2'
                            />
                        </div>

                        <div className='w-10/12 flex flex-col mt-5'>
                            <label htmlFor="eventname">Total sittings</label>
                            <input
                                id='eventname'
                                value={dataToEdit?.total_no_of_sitting}
                                onChange={(e) => setDataToEdit({ ...dataToEdit, total_no_of_sitting: e.target.value })}
                                type="text"
                                className='bg-success w-full h-10 rounded-lg border border-dashed border-gray-700 px-2'
                            />
                        </div>
                        {/* End of additional fields */}
                        <div className='flex flex-row justify-center mb-5 mt-10'>
                            <button className='px-4 py-2 bg-green-600 text-white rounded-full me-2' onClick={handleSubmitEdit}>Submit</button>
                            <button className='px-4 py-2 bg-success rounded-full ms-2' onClick={handleClose}>Cancel</button>
                        </div>
                    </div>
                </Box>
            </Modal>

            <Modal
                open={openMM}
                onClose={handleCloseMM}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={styleMM}>
                    <EditMemberMapping handleCloseModal={handleCloseMM} detailsTable={tableDetails} />
                </Box>
            </Modal>

            <Modal
                open={openSS}
                onClose={handleCloseSS}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={styleMM}>
                    <EditSittings handleCloseModalSS={handleCloseSS} detailsTable={tableDetails} />
                </Box>
            </Modal>

            <Modal
                open={open4}
                onClose={handleClose4}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style4}>
                    <DeleteModal deleteRow={deleteRow} handleClose4={handleClose4} open4={open4} />
                </Box>
            </Modal>
            <ToastContainer
                position="top-center"
                autoClose={4000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                draggable
                pauseOnHover
                theme="light"
            />

        </>
    )
}

export default TableSession